import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './components/auth/signin/signin.component';
import { UserPermission, UserRole } from './enums/enums';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthGuard } from './services/app/auth-guard/auth.guard';
import { PublicGuard } from './services/app/public-guard/public.guard';
import { ProfileComponent } from './components/profile/profile.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { NotificationsComponent } from './components/shared/layout/notifications/notifications.component';
import { CreateTripComponent } from './components/distributions/trip-intake/create-trip/create-trip.component';
import { MemberListComponent } from './components/distributions/members/member-list/member-list.component';
import { AddMemberComponent } from './components/distributions/members/add-member/add-member.component';
import { FileParsingComponent } from './components/distributions/trip-intake/file-parsing/file-parsing/file-parsing.component';
import { TripListComponent } from './components/distributions/trips/trip-list/trip-list.component';
import { StandingOrderListComponent } from './components/distributions/trip-intake/standing-order/standing-order-list/standing-order-list.component';
import { TripMonitoringComponent } from './components/distributions/trips/trip-monitoring/trip-monitoring.component';
import { StandingOrderTripWrapperComponent } from './components/distributions/trip-intake/standing-order/standing-order-trip-wrapper/standing-order-trip-wrapper.component';
import { PermissionGuard } from './services/app/permission-guard/permission.guard';
import { orderedSyncGuards } from './services/app/order-sequential-guard/orderSequential.guard';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password/forgot-password.component';
import { BillingListComponent } from './components/billing/billing-list/billing-list.component';
import { PaymentsListComponent } from './components/payments/payments-list/payments-list.component';
import { TransactionsListComponent } from './components/payments/transactions-list/transactions-list.component';
import { TutorialsListComponent } from './components/tutorials/tutorials-list/tutorials-list.component';
import { StatisticsComponent } from './components/statistics/statistics.component';

import { SupportTicketsComponent } from './components/support/support-tickets/support-tickets.component';
import { SupportChatComponent } from './components/support/support-chat/support-chat.component';
import { TicketDetailComponent } from './components/support/ticket-detail/ticket-detail.component';
import { AddSupportTicketComponent } from './components/support/add-support-ticket/add-support-ticket.component';

const routes: Routes = [
  { path: 'login', component: SigninComponent, canActivate: [PublicGuard] },

  { path: '', redirectTo: '/trips', pathMatch: 'full' },

  // {
  //   path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: {
  //     role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
  //   }
  // },

  // profile
  {
    path: 'profile', component: ProfileComponent, canActivate: [AuthGuard], 
  },

  //members

  {
    path: 'members',
    component: MemberListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_MEMBER]
    }
  },
  {
    path: 'members/add',
    component: AddMemberComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_MEMBER]
    }
  },
  {
    path: 'members/:memberId/edit',
    component: AddMemberComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_MEMBER]
    }
  },

  {
    path: 'parsetrips',
    component: FileParsingComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_MEMBER_TRIP, UserPermission.MANAGE_FUNDING_SOURCE_TRIP]
    }
  },


  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    canActivate: [AuthGuard],
     data: {
      permissions:[UserPermission.GET_NOTIFICATION]
    }
  },

  // Trips

  {
    path: 'trips',
    component: TripListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions:[UserPermission.GET_TRIP]
    } 
  },
  {
    path: 'trips/new',
    component: CreateTripComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_TRIP]
    }
  },
  {
    path: 'trips/:tripId/edit',
    component: CreateTripComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_TRIP]
    }
  },
  {
    path: 'trips/parsetrips',
    component: FileParsingComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_TRIP]
    }
  },
  {
    path: 'trips/standing-order',
    component: StandingOrderListComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions:[UserPermission.GET_STANDING_ORDER]
    }
  },
  {
    path: 'trips/standing-order/new',
    component: StandingOrderTripWrapperComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions:[UserPermission.MANAGE_STANDING_ORDER]
    }
  },
  {
    path: 'trips/standing-order/:standingOrderId/edit',
    component: StandingOrderTripWrapperComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_STANDING_ORDER]
    }
  },
  {
    path: 'trips/monitoring',
    component: TripMonitoringComponent,
    canActivate: [orderedSyncGuards([AuthGuard, PermissionGuard])],
     data: {
      permissions:[UserPermission.GET_TRIP]
    }
  },

   {
    path: 'payments',
    component: PaymentsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard,PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_PAYMENT]
    } 
  },
  {
    path: 'payments/transactions',
    component: TransactionsListComponent,
    canActivate: [orderedSyncGuards([AuthGuard,PermissionGuard])],
    data: {
      permissions: [UserPermission.MANAGE_PAYMENT]
    } 
  },
  // billing
  {
    path: 'billing',
    component: BillingListComponent,
    canActivate: [orderedSyncGuards([AuthGuard,PermissionGuard])],
    data: {
      permissions: [UserPermission.GET_FUNDINGSOURCE_BILLINGS]
    }
  },
    // tutorials
  // support
  {
    path: 'support',
    redirectTo: 'support/tickets',
    pathMatch: 'full'
  },
  {
    path: 'support/tickets',
    component: SupportTicketsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/chats',
    component: SupportChatComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/tickets/add',
    component: AddSupportTicketComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/tickets/:id',
    component: TicketDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'academy',
    component: TutorialsListComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.MANAGE_ACADEMY]
    }
  },
   {
    path: 'statistics',
    component: StatisticsComponent,
    canActivate: [AuthGuard],
    data: {
      permissions: [UserPermission.GET_TRIP]
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
